const currencyConfig = {
  bra: {
    locale: 'pt-BR',
    currency: 'BRL'
  },
  usa: {
    locale: 'en-US',
    currency: 'USD'
  },
  pry: {
    locale: 'es-PY',
    currency: 'PYG'
  },
  esp: {
    locale: 'es-ES',
    currency: 'EUR'
  }
}

export function formatCurrency(value) {
  const number =
    value === null || value === undefined || value === ''
      ? 0
      : parseFloat(value)

  if (isNaN(number)) {
    return ''
  }

  const country = localStorage.getItem('country') || 'bra'
  const config = currencyConfig[country] || currencyConfig.bra

  return number.toLocaleString(config.locale, {
    style: 'currency',
    currency: config.currency
  })
}
